(() => {
  if (window.parkReturnCalculatorInstalled) return;
  window.parkReturnCalculatorInstalled = true;
  const initialize = (scope) => {
    scope.querySelectorAll('[data-return-calculator]').forEach((calculator) => {
      if (calculator.dataset.initialized) return;
      const minus = calculator.querySelector('[data-return-minus]');
      const plus = calculator.querySelector('[data-return-plus]');
      const count = calculator.querySelector('[data-return-count]');
      const amount = calculator.querySelector('[data-return-amount]');
      if (!minus || !plus || !count || !amount) return;
      calculator.dataset.initialized = 'true';
      let quantity = 1;
      const render = () => {
        count.textContent = `${quantity} ${quantity === 1 ? calculator.dataset.singular : calculator.dataset.plural}`;
        amount.textContent = `${quantity * 20} ${calculator.dataset.currency}`;
        const countWidth = Number(quantity === 1 ? calculator.dataset.singularWidth : calculator.dataset.pluralWidth);
        count.style.maxWidth = countWidth > 0 ? `min(100%, ${countWidth}px)` : '';
        const amountWidth = Number(calculator.dataset.currencyWidth);
        amount.style.maxWidth = amountWidth > 0 ? `min(100%, ${amountWidth}px)` : '';
        amount.style.marginInline = amountWidth > 0 ? 'auto' : '';
        minus.disabled = quantity === 1;
        plus.disabled = quantity === 20;
      };
      minus.addEventListener('click', () => { quantity = Math.max(1, quantity - 1); render(); });
      plus.addEventListener('click', () => { quantity = Math.min(20, quantity + 1); render(); });
      render();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
